import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { PhonePrefixes } from "../models/phone-prefixes";

@Injectable({
  providedIn: "root",
})
export class PhonePrefixesService {
  private endpoint = "phonePrefixes";
  private baseUrl = environment.apiConfig.uri;
  private endpointUrl: string;
  constructor(private http: HttpClient) {
    this.endpointUrl = this.baseUrl + this.endpoint;
  }

  getPhonePrefixes(): Observable<PhonePrefixes[]> {
    return this.http.get<PhonePrefixes[]>(this.endpointUrl);
  }
}
